import React from 'react';

import { Providers } from './containers';
import { App } from './App';

interface AppWrapperProps {

}

export const AppWrapper: React.FC<AppWrapperProps> = () => {
  return (
    <Providers>
      <App />
    </Providers>
  );
};
